module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kindeditor"
  }, [_c('textarea', {
    attrs: {
      "id": _vm.id,
      "name": "content"
    }
  }, [_vm._v(_vm._s(_vm.outContent))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-40d87124"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/KindEditor/KindEditor.vue
// module id = 1466
// module chunks = 1